// Public connection details for the Supabase project. Both values are meant to be
// public (they ship in every browser); access is enforced by row-level security.
// Never put the service-role / secret key anywhere in this app.
export const SUPABASE_URL = 'https://ecgskwekeitfqtjvprao.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_094bmRXoj_dMV0mgfiTOzg_vGenBGHB';

// Google sign-in needs OAuth credentials set up in Google Cloud + Supabase first.
export const GOOGLE_SIGN_IN_ENABLED = false;
